import React, { memo, forwardRef, useImperativeHandle, useRef, useMemo } from 'react';
import { Form, Input } from 'antd';
import { Formik, FormikProps } from 'formik';
import * as yup from 'yup';
import { QuerySearch } from '../form/query-search';
import { BrandApi } from '../../apis';

const validationSchema = yup.object().shape({
  name: yup.string().required('Заавал оруулна'),
  source: yup.string().required('Заавал оруулна'),
  sourceUrl: yup.string().required('Заавал оруулна'),
  score: yup.number().required('Заавал оруулна'),
  carBrandId: yup.string().required('Заавал оруулна'),
});

type FormValues = {
  carBrandId: string | undefined;
  name: string | undefined;
  source: string | undefined;
  sourceUrl: string | undefined;
  score: number | undefined;
};

type Props = {
  onSubmit: (values: any) => void;
  action: any;
};

export type BrandFormRef = {
  submitForm: () => any;
  getValues: () => any;
};

const ModelForm = memo(
  forwardRef<BrandFormRef, Props>(({ onSubmit: _onSubmit, action }, ref) => {
    const formikRef = useRef<FormikProps<FormValues>>(null);

    useImperativeHandle(ref, () => ({
      submitForm: async () => {
        const validate = await formikRef.current?.submitForm();
        return validate;
      },
      getValues: () => {},
    }));

    const initialValues = useMemo(() => {
      console.log('action :', action);
      return {
        name: undefined,
        nameEng: undefined,
        ...(action && {
          name: action.name,
          source: action.source,
          sourceUrl: action.sourceUrl,
          score: action.score,
          carBrandId: action.carBrandId,
        }),
      };
    }, [action]);

    return (
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={_onSubmit}
        innerRef={formikRef}
      >
        {({ handleChange, values, errors, touched, setFieldValue }) => {
          return (
            <>
              <Form layout="vertical">
                <div className="card">
                  <div className="inputContainer">
                    <Form.Item
                      label="Брэнд"
                      layout="vertical"
                      validateStatus={errors.carBrandId && touched.carBrandId ? 'error' : ''}
                      help={
                        errors.carBrandId && touched.carBrandId ? errors.carBrandId : ('' as any)
                      }
                    >
                      <QuerySearch
                        value={values.carBrandId}
                        onChange={(e) => setFieldValue('carBrandId', e)}
                        placeholder="Брэнд сонгох"
                        showSearch
                        loadData={BrandApi.select}
                      />
                    </Form.Item>

                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Form.Item
                          label="Нэр"
                          layout="vertical"
                          validateStatus={errors.name && touched.name ? 'error' : ''}
                          help={errors.name && touched.name ? errors.name : ('' as any)}
                        >
                          <Input
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            placeholder="Нэр"
                            status={touched.name && errors.name ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                      <div className="w-[13px]" />
                      <div className="flex-1">
                        <Form.Item
                          label="Source"
                          layout="vertical"
                          validateStatus={errors.source && touched.source ? 'error' : ''}
                          help={errors.source && touched.source ? errors.source : ('' as any)}
                        >
                          <Input
                            name="source"
                            value={values.source}
                            onChange={handleChange}
                            placeholder="Source"
                            status={touched.source && errors.source ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                    </div>

                    <div className="flex flex-row">
                      <div className="flex-1">
                        <Form.Item
                          label="Source url"
                          layout="vertical"
                          validateStatus={errors.sourceUrl && touched.sourceUrl ? 'error' : ''}
                          help={
                            errors.sourceUrl && touched.sourceUrl ? errors.sourceUrl : ('' as any)
                          }
                        >
                          <Input
                            name="sourceUrl"
                            value={values.sourceUrl}
                            onChange={handleChange}
                            placeholder="Нэр"
                            status={touched.sourceUrl && errors.sourceUrl ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                      <div className="w-[13px]" />
                      <div className="flex-1">
                        <Form.Item
                          label="Score"
                          layout="vertical"
                          validateStatus={errors.score && touched.score ? 'error' : ''}
                          help={errors.score && touched.score ? errors.score : ('' as any)}
                        >
                          <Input
                            name="score"
                            value={values.score}
                            onChange={handleChange}
                            placeholder="Score"
                            status={touched.source && errors.source ? 'error' : ''}
                          />
                        </Form.Item>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="h-[20px]" />
              </Form>
            </>
          );
        }}
      </Formik>
    );
  })
);

ModelForm.displayName = 'ModelForm';

export { ModelForm };
